import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

const links = [
  { label: 'Home',       hash: 'home'       },
  { label: 'About',      hash: 'about'      },
  { label: 'Tokenomics', hash: 'tokenomics' },
  { label: 'Roadmap',    hash: 'roadmap'    },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  function scrollToSection(hash) {
    setOpen(false);
    if (pathname === '/') {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${hash}`);
    }
  }

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <button className="navbar-logo" onClick={() => scrollToSection('home')}>
          MEME<span className="logo-cult">CULT</span>URE
        </button>

        <ul className={`navbar-links ${open ? 'open' : ''}`}>
          {links.map(({ label, hash }) => (
            <li key={hash}>
              <button onClick={() => scrollToSection(hash)}>
                {label}
              </button>
            </li>
          ))}
          <li>
            <a
              className="navbar-buy-btn"
              href="https://app.uniswap.org/swap?outputCurrency=0xaab77ed699f42ebc44edcf37d115c2a70414da2c"
              target="_blank"
              rel="noopener noreferrer"
            >
              Buy $CULT
            </a>
          </li>
        </ul>

        <button
          className={`hamburger ${open ? 'open' : ''}`}
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
